<template>
  <div class="space-y-12">
    <section>
      <div 
        class="yh__grid-container"
        :class="{ mobile: isMobile }">
        <div
          v-for="number in GRID_NUMBERS"
          :key="`grid-${number}`"
          :class="[getGridItemClass(number), { mobile: isMobile }]"
          class="yh__grid-item yh__hover-lift"
          role="button"
          tabindex="0"
          @mouseenter="onHover(number)"
          @mouseleave="onLeave"
        >
          {{ number }}
        </div>
      </div>

      <div class="yh__legend-wrap">
        <button
          class="yh__legend-btn"
          :data-active="legend === '용신'"
          @click="toggleLegend('용신')"
          aria-pressed="legend === '용신'"
        >
          용신
        </button>
        <button
          class="yh__legend-btn"
          :data-active="legend === '희신'"
          @click="toggleLegend('희신')"
          aria-pressed="legend === '희신'"
        >
          희신
        </button>
      </div>
      <div class="yh__grid-desc">
        {{ description }}
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { getNumClass, parseNumberElements } from './yongsinUsage.js'

const props = defineProps({
  numbers: { type: Array, default: () => [] },
  isMobile: { type: Boolean, default: false },
})

const GRID_NUMBERS = Array.from({ length: 10 }, (_, i) => i + 1)

const hoveredNumber = ref(null)
const legend = ref('all') // 'all' | '용신' | '희신'
const description = ref('')
const yongsinDesc = computed(
  () => props.numbers.find(c => c?.title?.includes('용신'))?.description ?? '용신 숫자'
)
const heesinDesc = computed(
  () => props.numbers.find(c => c?.title?.includes('희신'))?.description ?? '희신 숫자'
)


const toggleLegend = (type) => {
  legend.value = legend.value === type ? 'all' : type
  switch(legend.value){
    case 'all':
      description.value = '';
      break;
    case '용신':
      description.value = yongsinDesc.value;
      break;
    case '희신':
      description.value = heesinDesc.value;
      break;
  }
}

const onHover = (n) => { hoveredNumber.value = n }
const onLeave = () => { hoveredNumber.value = null }

/** props.numbers -> 용신/희신 Set 정규화 */
const yongsinSet = computed(() => {
  const card = props.numbers.find(c => typeof c?.title === 'string' && c.title.includes('용신'))
  const list = parseNumberElements(card?.numbers ?? [])
  return new Set(list.map(Number).filter(Number.isFinite))
})
const heesinSet = computed(() => {
  const card = props.numbers.find(c => typeof c?.title === 'string' && c.title.includes('희신'))
  const list = parseNumberElements(card?.numbers ?? [])
  return new Set(list.map(Number).filter(Number.isFinite))
})

/** 타입 판정 */
const getElementType = (num) => {
  if (yongsinSet.value.has(num)) return '용신'
  if (heesinSet.value.has(num))  return '희신'
  return '기타'
}

/** 클래스 */
const getGridItemClass = (number) => {
  const type = getElementType(number)
  const baseClass = 'yh__grid-item-base'
  const hoverClass = hoveredNumber.value === number ? 'yh__chip-hover' : ''
  const filteredType = (legend.value === 'all')
    ? type
    : (legend.value === type ? type : '기타')
  if (filteredType === '기타') {
    return `${baseClass} yh__normal-color ${hoverClass}`
  }
  const numBgClass = getNumClass(number, { variant: 'bg' }) || ''
  return `${baseClass} ${numBgClass} ${hoverClass}`
}
</script>

<style scoped lang="scss">
@import '@/assets/nangman_style/_util.scss';

</style>
